import React from "react";

import DashboardMenu from "./dashboard/DashboardMenu";
import OverviewMenu from "./overviewMenu/OverviewMenu";

type MainContentProps = {
  children: React.ReactNode;
  showOverviewMenu?: boolean;
};

function MainContent({ children, showOverviewMenu = false }: MainContentProps) {
  return (
    <div className="dashboard-wrap">
      <DashboardMenu />
      <div className="dashboard-wrap__main">{children}</div>
      {showOverviewMenu && <OverviewMenu />}
    </div>
  );
}

export default MainContent;
